

































































































































































































import { Vue, Prop, Watch, Component } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';
import CommentModal from './CommentModal.vue';
import ChangelogModal from './ChangelogModal.vue';

interface Obl {
    code: string; 
    obl: string; 
    region: string;
}

interface IFormHeader {
    key: string;
    label: string;
}

interface IAteType {
    code: string; 
    name: string;
    $isDisabled?: boolean;
}

interface IDistrict {
    code: string; 
    name: string | TranslateResult;
}

interface IRDistrict {
    code: string;   
    name: string | TranslateResult;
}

interface ISnp {
    code: string; 
    name: string | TranslateResult;
    open?: boolean
}

interface ISrsStatus {
    code: string; 
    name: string | TranslateResult;
}

interface IDirection {
    code: string; 
    name: string | TranslateResult;
    status: ISrsStatus; 
    comment: string; 
}

interface IYear {
  id: string;
  year: number;
}

interface IFilterData {
    ate: IAteType;
    district: IDistrict;
    ruralDistrictList: IRDistrict[];
    ruralDistrict: IRDistrict;
    snpList: ISnp[];
    snp: ISnp;
    directionList: IDirection[];
    direction: IDirection;
    year: IYear;
};

interface ISnpWithDirections extends ISnp {
    directions: IDirection[];
}

interface IRuralDistrictData {
    rur_dist: IRDistrict;
    snp: ISnpWithDirections[];  
    open?: boolean;
}

type ISnpsByRuralDistrict = Record<string, IRuralDistrictData>;

interface ISnpFormData {
    district: IDistrict;
    snps: ISnpsByRuralDistrict;
}

interface IJournalDataItem {
    status: string; 
    comment: string;
    name: string; 
    created_at: Date; 
}

type IJournalData = IJournalDataItem[]; 


@Component({
    components: {
        CommentModal,
        ChangelogModal,
    }
})
export default class SrsAgree extends Vue {
    @Prop({ default: null }) filterData!: IFilterData | null;

    obl: Obl = {code: '', obl: '', region: ''};
    moduleCode = '003.009.003';
    snpFormData: ISnpFormData | null = null;
    selectedForms: Record<string, boolean> = {}; // key format: `${snpCode}-${directionCode}`
    currButtons: Record<string, {
        agr_code: string, 
        status_name: string, 
        button_name: string}
    > = {};
    allOpen: boolean = true; 
    activeAgrCode: string | null = null;
    popoverVisible: Record<string, boolean> = {};
    journalData: IJournalData = [];
    currUserCodes: string[] = [];  // разрешённые пользователю статусы


    async mounted() {
        await this.getObl();
        await this.getSrsforms();
        await this.fetchCurrUserStatusCodes(); 
    }

    get formHeaders(): IFormHeader[] {
        return [
            { key: "action1", label: " " },
            { key: "action2", label: " " },
            { key: "name", label: "HП/СНП" },
            { key: "direction", label: "Направление" },
            { key: "status", label: "Статус согласования" },
            { key: "comment", label: "Примечание" },
            { key: "kebab", label: " " },
        ];
    }

    get statusCodesFromLowestToHighest(): Record<string, number> {
        return {
            '1': 1,
            '82': 2,
            '81': 3,
            '83': 4,
            '85': 5,
            '84': 6,
            '86': 7,
            '88': 8,
            '87': 9,
            '89': 10,
            '91': 11,
            '90': 12,
            '92': 13,
            '93': 14,
        };
    }

    getNormalizedLocale(locale=this.$i18n.locale): string {
        return (locale === 'kk' || locale === 'kz') ? 'kz' : 'ru';
    }

    @Watch('filterData', { immediate: false })
    async onFilterDataChange(newFilterData: IFilterData | null) {
        if (newFilterData) {
            await this.getSrsforms();
            await this.fetchCurrUserStatusCodes();
        }
    }


    hidePopover(key: string) {
        this.$set(this.popoverVisible, key, false);
    }

    async onChangelogShow(snpCode: string, dirCode: string) {
        const year = this.filterData?.year?.year || 0;
        await this.getJournalData(snpCode, dirCode, year);
        const changelogModal = this.$refs.changelogModal as any;
        changelogModal.show();
    }

    async onButtonClick(agrCode: string) {
        if (['82', '85', '88', '91'].includes(agrCode)) {
            const commentModal = this.$refs.commentModal as any;
            commentModal.show();
            this.activeAgrCode = agrCode;
            return; 
        }
        await this.updateFormStatus(agrCode);
    }

    async onCheckboxChange(agrCode: string, checked: boolean) {
        const noCheckedForms = Object.values(this.selectedForms).every(v => !v) 
        if (noCheckedForms) {
            // убрать кнопки если ничего не выбрано
            this.currButtons = {};
            this.clearCheckedForms();
        } else if (checked) {
            await this.fetchStatusButtons(agrCode);
        }
    }

    async onSaveComment(comment: string) {
        if (this.activeAgrCode) {
            await this.updateFormStatus(this.activeAgrCode, comment);
        }
        this.activeAgrCode = null; 
    }

    async onSaveNoComment() {
        if (this.activeAgrCode) {
            await this.updateFormStatus(this.activeAgrCode);
        }
        this.activeAgrCode = null; 
    }


    async getObl(): Promise<void> {
        try {
            const response = await fetch(`/api-py/get-budget-obl/${this.$store.state._instanceCode}`)
            this.obl = await response.json();
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                String(this.$t('modules.srs.warnings.get_obl_error')), 
                err.message || err.toString()
            );
        }
    }

    async getSrsforms() {
        try {
            if (!this.filterData) {
                return;
            }

            const userData = { 
              userId: this.$store.getters.user_uuid,
              moduleCode: this.moduleCode 
            };

            const payload = {
                ...userData,
                ...this.filterData,
            };  

            const response = await fetch(`/api-py/srs/agree/form/${this.obl.code}?lang=${this.getNormalizedLocale()}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            const data = await response.json();
        
        // Make 'open' properties reactive
        if (data?.snps) {
            for (const rurCode of Object.keys(data.snps)) {
                const ruralDistrict = data.snps[rurCode];
                this.$set(ruralDistrict, 'open', ruralDistrict.open ?? true);
                for (const snp of ruralDistrict.snp) {
                    this.$set(snp, 'open', snp.open ?? true);
                }
            }
        }
        this.snpFormData = data;

        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                'Error fetching getSrsforms()',
                err.message || err.toString()
            );
        }
    }

    async fetchStatusButtons(agrCode: string) {

        const isSame = this.isSameStatusForCheckedForms().isSame;
        if (!isSame) {
            this.makeToast(
                'warning',
                'Выбранные формы должны иметь одинаковый статус',
                'Внимание'
            )
            this.$nextTick(() => {
                const lowestStatusCode = this.onlyLeaveCheckedFormsWithLowestStatusCodes(); 
                if (lowestStatusCode !== '999') {
                    this.fetchStatusButtons(lowestStatusCode);
                }
            });
            this.currButtons = {}; 
            return;
        }

        // do not fetch buttons if any form is already checked
        const anyCheckedForm = Object.values(this.selectedForms).filter(v => v);
        if (anyCheckedForm.length > 1 && this.currButtons[agrCode]) {
            return;
        } else if (anyCheckedForm.length > 1) {
            this.currButtons = {};
        }
        
        const payLoad = {
            userId: this.$store.getters.user_uuid,
            moduleCode: this.moduleCode,
            agrCode: agrCode,
        };

        try {
            const response = await fetch(`/api-py/srs/agree/form/buttons?lang=${this.getNormalizedLocale()}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payLoad),
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const resp = await response.json();
            for (const button of resp) {
                this.$set(this.currButtons, button.agr_code, button);
            }
            
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                'Error fetching fetchStatusButtons()', 
                err.message || err.toString()
            );
        }

    }

    async fetchCurrUserStatusCodes() {
        const payLoad = {
            userId: this.$store.getters.user_uuid,
            moduleCode: this.moduleCode,
        };

        try {
            const response = await fetch('/api-py/srs/agree/user/operations', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payLoad),
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            const data = await response.json();
            this.currUserCodes = data;

        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger',
                'Error fetching fetchCurrUserStatusCodes()',
                err.message || err.toString()
            );
        }
    }

    async updateFormStatus(agrCode: string, comment?: string) {
        const snps = []; 

        for (const [key, value] of Object.entries(this.selectedForms)) {
            if (value) {
                const [snpCode, directionCode] = key.split('-');
                snps.push({snpCode, directionCode}); 
            }
        }

        if (snps.length === 0) {
            this.makeToast(
                'warning',
                'Не выбраны формы для обновления',
                'Внимание'
            )
            return; 
        }

        // Normalize comment: undefined or empty string → null
        const normalizedComment = comment?.trim() || null;
        const payLoad = {
            snps,
            year: this.filterData?.year?.year,
            agrCode,
            comment: normalizedComment,  
            userId: this.$store.getters.user_uuid,
        };
    
        try {
            const response = await fetch(`/api-py/srs/agree/form/update?lang=${this.getNormalizedLocale()}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payLoad),
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            await this.getSrsforms();
            this.currButtons = {};
            // reset checked forms
            for (const [key, value] of Object.entries(this.selectedForms)) {
                if (value) {
                    this.$set(this.selectedForms, key, false);
                }
            }

        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger',
                'Error fetching updateFormStatus()',
                err.message || err.toString()
            );
        }
    }


    async getJournalData(snpCode: string, dirCode: string, year: number) {
        try {
            const response = await fetch(`/api-py/srs/agree/journal?snpCode=${snpCode}&dirCode=${dirCode}&year=${year}&lang=${this.getNormalizedLocale()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            this.journalData = await response.json();
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                'Error fetching getJournalData()', 
                err.message || err.toString()
            );
        }
    }


    async checkAllForms(event: Event) {
        if (!this.snpFormData?.snps || Object.keys(this.snpFormData?.snps).length === 0) {
            return;
        }

        const checkbox = event.target as HTMLInputElement;
        const isChecked = checkbox.checked;
        const { formKeys: allFormKeys, allChecked } = this.isAllFormsChecked();
        
        if (!isChecked) {
            // Checkbox is being unchecked - clear all selections
            allFormKeys.forEach(key => {
                this.$set(this.selectedForms, key, false);
            });
            this.currButtons = {};
            return;
        }

        if (allChecked) {
            // Если все выбраны - снять все
            allFormKeys.forEach(key => {
                this.$set(this.selectedForms, key, false);
            });
            this.currButtons = {};
        } else {
            // Если не все выбраны - выбрать все
            allFormKeys.forEach(key => {
                this.$set(this.selectedForms, key, true);
            });

            const {res, isSame} = this.isSameStatusForCheckedForms();
            if (!isSame) {
                this.makeToast(
                    'warning',
                    'Выбранные формы должны иметь одинаковый статус',
                    'Внимание'
                )

                const lowestStatusCode = this.onlyLeaveCheckedFormsWithLowestStatusCodes() 
                if (lowestStatusCode !== '999') {
                    this.fetchStatusButtons(lowestStatusCode);
                    return; 
                }
            }
            
            const agrCode = res[0];
            await this.fetchStatusButtons(agrCode); 
        }
    }

    onlyLeaveCheckedFormsWithLowestStatusCodes(): string {
        let lowestStatusCode: string = '999'; // arbitrary highest status code
        
        for (const [key, value] of Object.entries(this.selectedForms)) {
            if (value) {
                const [snpCode, directionCode] = key.split('-');
                const snp = this.findSnp(snpCode, directionCode);
                if (snp) {
                    for (const dir of snp.directions) {
                        if (dir.code === directionCode) {
                            const currentStatusCode = dir.status.code;
                            const currCode = this.statusCodesFromLowestToHighest[currentStatusCode];
                            const lowCode = (
                                lowestStatusCode === '999' ? 15 
                                : this.statusCodesFromLowestToHighest[lowestStatusCode] 
                            );

                            if (currCode < lowCode) {
                                lowestStatusCode = currentStatusCode;
                            }
                            break;
                        }
                    }
                }
            }
        }

        // If no forms were checked
        if (lowestStatusCode === '999') {
            return '999';
        }

        const keysToUncheck: string[] = [];
        for (const [key, value] of Object.entries(this.selectedForms)) {
            if (value) {
                const [snpCode, directionCode] = key.split('-');
                const snp = this.findSnp(snpCode, directionCode);
                if (snp) {
                    for (const dir of snp.directions) {
                        if (dir.code === directionCode) {
                            if (dir.status.code !== lowestStatusCode) {
                                keysToUncheck.push(key);
                            }
                            break;
                        }
                    }
                }
            }
        }
        
        for (const key of keysToUncheck) {
            this.$set(this.selectedForms, key, false);
        }
        return lowestStatusCode;
    }


    isAllFormsChecked(): { formKeys: string[], allChecked: boolean } {
        if (!this.snpFormData?.snps || Object.keys(this.snpFormData?.snps).length === 0) {
            return { formKeys: [], allChecked: false }; 
        }

        const allFormKeys: string[] = [];
        for (const rurCode of Object.keys(this.snpFormData.snps)) {
            const ruralDistrict = this.snpFormData.snps[rurCode];
            for (const snp of ruralDistrict.snp) {
                for (const direction of snp.directions) {
                    const key = `${snp.code}-${direction.code}`;
                    allFormKeys.push(key);
                }
            }
        }
        const allChecked = allFormKeys.every(key => this.selectedForms[key] === true);
        return { formKeys: allFormKeys, allChecked }; 
    }


    clearCheckedForms() {
        for (const [key, value] of Object.entries(this.selectedForms)) {
            if (value) {
                this.$set(this.selectedForms, key, false); 
            }
        }
        this.currButtons = {};
    }


    isSameStatusForCheckedForms(): { res: string[], isSame: boolean } {
        const res: string[] = []; 
        for (const [key, value] of Object.entries(this.selectedForms)) {
            if (value) {
                const [snpCode, directionCode] = key.split('-');
                const snp = this.findSnp(snpCode, directionCode);
                if (snp) {
                    for (const dir of snp.directions) {
                        if (dir.code === directionCode) {
                            res.push(dir.status.code);
                            break; 
                        }
                    }
                }
            }
        }
         // Если нет выбранных форм
        if (res.length === 0) {
            return { res, isSame: false };
        }
        // Проверить что все статусы одинаковые
        return { res, isSame: res.every(status => status === res[0]) }; 
    }


    findSnp(snpCode: string, dirCode: string): ISnpWithDirections | null {
        if (!this.snpFormData) {
            return null;
        }

        for (const rurCode of Object.keys(this.snpFormData.snps)) {
            const ruralDistrict = this.snpFormData.snps[rurCode];
            for (const snp of ruralDistrict.snp) {
                if (snp.code === snpCode) {
                    const hasDirection = snp.directions.some(dir => dir.code === dirCode);                    
                    if (hasDirection) {
                        return snp;
                    }
                }
            }
        }
        return null;
    }

    renderButtonColor(agrCode: string): string {
        return (
            ['83', '86', '89'].includes(agrCode) ? 'primary'
            : ['81', '82', '84', '85', '87', '88', '90', '91'].includes(agrCode) ? 'secondary'
            : agrCode === '92' ? 'success'
            : agrCode === '93' ? 'danger'
            : ''
        );
    }

    toggleAll() {    
        if (!this.snpFormData?.snps || Object.keys(this.snpFormData?.snps).length === 0) {
            return; 
        }
        
        this.allOpen = !this.allOpen;
        for (const rurCode of Object.keys(this.snpFormData.snps)) {
            const ruralDistrict = this.snpFormData.snps[rurCode];
            this.$set(ruralDistrict, 'open', this.allOpen);
            for (const snp of ruralDistrict.snp) {
                this.$set(snp, 'open', this.allOpen);
            }
        }
    }

    toggleRuralDistrict(rurDistCode: string) {
        if (!this.snpFormData?.snps) {
            return;
        }
        
        for (const rurCode of Object.keys(this.snpFormData.snps)) {
            const ruralDistrict = this.snpFormData.snps[rurCode];
            if (ruralDistrict.rur_dist.code === rurDistCode) {
                this.$set(ruralDistrict, 'open', !ruralDistrict.open);
                return;
            }
        }
    }

    toggleSnpItem(snpCode: string) {
        if (!this.snpFormData?.snps || Object.keys(this.snpFormData?.snps).length === 0) {
            return; 
        }
        for (const rurCode of Object.keys(this.snpFormData.snps)) {
            const ruralDistrict = this.snpFormData.snps[rurCode];
            for (const snp of ruralDistrict.snp) {
                if (snp.code === snpCode) {
                    this.$set(snp, 'open', !snp.open);
                    return;
                }
            }
        }
    }

    makeToast(variant: string, tostbody: string, title: string, autoHideDelay?: number): void {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            autoHideDelay: autoHideDelay || 3500,
            solid: true
        });
    }

}
